import { render, staticRenderFns } from "./Item.vue?vue&type=template&id=ff55e32e&shadow"
import script from "./Item.vue?vue&type=script&lang=js&shadow"
export * from "./Item.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./Item.vue?vue&type=style&index=0&id=ff55e32e&prod&lang=scss&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports